/*
 * AniButton
 *
 * This combines the styling of an MUI Button component with the page transitions of the AniLink component
 */

import React from 'react';
import PropTypes from 'prop-types';
import AniLink from 'gatsby-plugin-transition-link/AniLink';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import clsx from 'clsx';

//////////////////////////

const useStyles = makeStyles({
  adaptiveButton: {
    width: "auto",
  },
});

//////////////////////////

const propTypes = {
  variant: PropTypes.string,
  size: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.any.isRequired,
};

export const AniButton = props => {

  const classes = useStyles({});
  const {
    variant,
    size,
    className,
    children,
    color,
    ...rest
  } = props;

  //////

  return (

    <AniLink
      {...rest}
      style = {{
        textDecoration: 'none',
      }}
      >
      <Button
        variant = {variant}
        size = {size}
        color = {color}
        className = {clsx(classes.adaptiveButton, className)}
        >
        {children}
      </Button>
    </AniLink>

  );

};

AniButton.propTypes = propTypes;
export default AniButton;
